module.exports = __webpack_public_path__ + "img/expostyle_0954_marine.978ae170.jpg";